import React, { Component } from 'react'
// import Store from 'store'

class Layer extends Component {
  render () {
    let style = {
      zIndex: this.props.zIndex || '0'
    }
    switch (this.props.type) {
      case 'img':
        style.backgroundImage = 'url(' + this.props.asset + ')'
        break
      case 'placeholder' :
      default :
        style.backgroundImage = 'url(http://via.placeholder.com/1280x720?' +
          'text=' + this.props.asset.replace(' ', '+') + ')'
        break
    }

    return (
      <div style={style} className='visualize-layer'>
        {this.props.children}
      </div>
    )
  }
}

export default Layer



// WEBPACK FOOTER //
// ./src/lib/react-visualize/Core/Layer.js